module.exports = __webpack_public_path__ + "static/media/admiralsclub.15eb78f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spaceteam/admiralsclub.png
// module id = 180
// module chunks = 0